module.exports = __webpack_public_path__ + "img/userC01.c8b81cfc.jpg";